/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../../Layouts/Mainlayout';
import ReactGanttChart from './BulkEmailGanttChart'; // Import the shared component

export default function GanttSchedulePage(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <h2 className="text-2xl font-semibold text-title  mb-[20px]">Bulk Email Schedule</h2>
        <ReactGanttChart />
      </MainLayout>
    </div>
  );
}